export const PERMS = {
    READ: 'report_app_usage.read',
}
